export default __webpack_public_path__ + "static/media/cost-optimization.8b3f76dd.png";